import { Lock } from "lucide-react";
import { cn } from "../../utils/tailwindUtils";

export const DEFAULT_SALARY_PAYSLIP_LOCK_MESSAGE =
    "Salary and payslip details are temporarily unavailable while payroll is being processed. Please contact HR if you need assistance.";

/**
 * FR-042 — frosted overlay with lock icon over Salary / Payslips tab content.
 * Tab stays visible; content beneath is blurred/non-interactive.
 */
const PayrollProfileLockOverlay = ({
    locked = false,
    message = DEFAULT_SALARY_PAYSLIP_LOCK_MESSAGE,
    title = "Access temporarily locked",
    children,
    className,
}) => {
    if (!locked) {
        return children;
    }

    return (
        <div className={cn("relative min-h-[320px]", className)}>
            <div className="pointer-events-none select-none opacity-40 blur-[1px]" aria-hidden="true">
                {children}
            </div>
            <div
                className="absolute inset-0 z-10 flex flex-col items-center justify-center rounded-xl bg-white/70 dark:bg-gray-900/75 backdrop-blur-sm border border-amber-200/60 dark:border-amber-800/50 px-6 py-10 text-center"
                role="status"
                aria-live="polite"
            >
                <span className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 shadow-inner">
                    <Lock className="h-8 w-8" strokeWidth={1.75} />
                </span>
                <h4 className="text-base font-semibold text-gray-900 dark:text-gray-100 mb-2">
                    {title}
                </h4>
                <p className="text-sm text-gray-600 dark:text-gray-300 max-w-md leading-relaxed">
                    {message}
                </p>
            </div>
        </div>
    );
};

export default PayrollProfileLockOverlay;
